import { Type } from '@angular/core';
import { FilterTypesEnum } from '../../../../Common/Filter/enums/filters-types.enum';
import { AbstractFilterTypeComponent } from '../../../../Common/Filter/models/abstract-filter-type.component';
import { CustomFilterTypeModel } from '../../../../Common/Filter/models/custom-filter-type.model';
import { FilterOptionModel } from '../../../../Common/Filter/models/filter-option.model';
import { FilterQuickOptionModel } from '../../../../Common/Filter/models/filter-quick-option.model';
import { FilterTypeCheckboxModel } from '../../../../Common/Filter/models/filter-type-checkbox.model';
import { ChipModel } from '../../../../Common/Forms/models/chip.model';
import _ from 'underscore';


export class FilterTypeTagCheckboxModel extends FilterTypeCheckboxModel<number> implements CustomFilterTypeModel<number[]> {
    readonly key: FilterTypesEnum = FilterTypesEnum.custom;

    customComponent: Type<AbstractFilterTypeComponent>;
    hasMoreOptions: boolean = false;
    moreOptions: FilterOptionModel<number>[] = [];

    constructor(
        id: string,
        label: string,
        component: Type<AbstractFilterTypeComponent>,
        options?: FilterOptionModel<number>[],
        value?: number[],
        section?: string
    ) {
        super(id, label, options, true, null, value, undefined, undefined, section);
        this.customComponent = component;
    }

    clear(): void {
        this.setValue([]);
    }

    setValue(value: number[]): void {
        this.value = value;

        if (this.options) {
            const options = this.options.concat(this.moreOptions);
            this.chips = this.value.map(tagId => {
                return _.clone(options.find(option => option.value === tagId));
            }).filter(chip => !!chip);
        }

        this.cancelChanges();
    }

    setCurrentValue(value: number[]): void {
        this.currentValue = value;

        if (this.options) {
            const options = this.options.concat(this.moreOptions);
            this.currentChips = this.currentValue.map(tagId => {
                return options.find(option => option.value === tagId);
            }).filter(chip => !!chip);
        }

        this.updateCurrentChipSuffix();
    }

    setMoreOptions(options: FilterOptionModel[]): void {
        this.moreOptions = options;
    }

    removeChip(chip: ChipModel): void {
        this.value = this.value
            .filter(tagId => tagId !== (<any>chip).value);

        this.setValue(this.value);
    }

    removeCurrentChip(chip: ChipModel): void {
        this.currentValue = this.currentValue
            .filter(tagId => tagId !== (<any>chip).value);

        this.setCurrentValue(this.currentValue);
    }

    quickAutocomplete(query: string, translateMethod: (str: string) => string): FilterQuickOptionModel<number>[] {
        const queryLower = query.toLocaleLowerCase();
        const matchedOptions = this.options.filter(
            opt => {
                if (this.value.includes(opt.value)) {
                    return false;
                }
                return opt.label.toLocaleLowerCase().includes(queryLower);
            }
        );

        return matchedOptions.map(opt => {
            return {
                label: opt.label,
                value: opt.value,
                count: opt.count,
                filter: this
            };
        });
    }
    addQuickOption(option: FilterQuickOptionModel<number>): void {
        this.setValue([...this.value, option.value]);
    }
}
